import { formatPhoneDigits, isValidValue, splitPhone } from "utils";

export const extractCountryCode = (number) => {
  if (!isValidValue(number) || number.length < 5) {
    return {
      number: null,
      countryCode: "+1",
      format: null,
      formattedNumber: null,
    };
  }

  // UA (+380) numbers have 9 digits after the code, the others 10
  const { countryCode, number: rawNumber } = splitPhone(number);
  const format = formatPhoneDigits(rawNumber);

  // combine country code + formatted number
  const formattedNumber = `${countryCode} ${format}`;

  return {
    number: rawNumber,
    countryCode,
    format,
    formattedNumber,
  };
};
